import { useState } from 'react'

export default function VideoPlayer({ src, slug, frame = 'landscape', poster }) {
  const [failed, setFailed] = useState(false)
  const frameClass = frame === 'portrait' ? 'video-player--portrait' : 'video-player--landscape'

  return (
    <div className={`video-player ${frameClass}`} data-testid="video-ready">
      <h3>Video walkthrough</h3>
      {!failed ? (
        <video
          data-testid={`video-el-${slug}`}
          src={src}
          poster={poster || undefined}
          controls
          playsInline
          preload="metadata"
          onError={() => setFailed(true)}
        >
          Your browser does not support video playback.
        </video>
      ) : null}
      {failed ? (
        <div data-testid="video-unavailable" className="video-unavailable">
          <p>Video unavailable — try again.</p>
          <p>This does not mean the product itself failed.</p>
          <button type="button" onClick={() => setFailed(false)}>
            Retry
          </button>
        </div>
      ) : null}
    </div>
  )
}
